const MuiInputBase = {
  styleOverrides: {
    root: {},
  },
};

export default MuiInputBase;
